import { Path, Svg } from './styles';
import { IconProps } from './types';

const path = [
  'M10.5003 1.66797C5.90033 1.66797 2.16699 5.4013 2.16699 10.0013C2.16699 14.6013 5.90033',
  '18.3346 10.5003 18.3346C15.1003 18.3346 18.8337 14.6013 18.8337 10.0013C18.8337 5.4013 15.1003',
  '1.66797 10.5003 1.66797ZM11.3337 14.168H9.66699V12.5013H11.3337V14.168ZM11.3337 10.8346H9.66699V5.83464H11.3337V10.8346Z',
].join(' ');

export const IconExclamationCircledFilled = ({ width = 21, height = 20, color, className }: IconProps) => (
  <Svg className={className} width={width} height={height} viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <Path fillRule="evenodd" clipRule="evenodd" d={path} fill={color} />
  </Svg>
);

export default IconExclamationCircledFilled;
